<template>
    <div class="pop-box1" v-show="waring">
        <div class="close" @click="Ahide()"></div>

        <div class="box-wargin">
            <ul class="list">
                <li v-for="(i, a) in property" :key="a">
                    <div></div>
                    <span>{{ i }}</span>
                    <div></div>
                </li>
            </ul>
            <ul class="list-now" v-for="(item, i) in separator" :key="i">
                <li>{{ item.time}}</li>
                <li>{{ item.NAME}}</li>
                <li>{{ item.ALARMNAME}}</li>
                <li>{{ item.ALARMVALUE}}</li>
                <li>{{ item.ALARMRH}}</li>
                <li>{{ item.ALARMRL}}</li>
            </ul>
        </div>

    </div>
</template>

<script>
    // import {getPolice} from './../api/index'
    export default {
        name: "PopUp",
        props:['waring'],
        data(){
            return {
                property: [
                    "时间",
                    "点位名称",
                    "报警参数",
                    "报警参数值",
                    "报警参数上限",
                    "报警参数下限",
                ],
                separator: [
                ],
            };
        },
        mounted(){
            this.getData();
        },
        methods:{
            getData(){
                let data = new Date();
                let year = data.getYear();
                let mouth = data.getMonth()+1;
                let day= data.getDate();
                let time = year+":"+mouth+":"+day + " 00:00:00"
                // getPolice({
                //     where:'(item,gt,'+time+')'
                // })
                //     .then((data)=>{
                //         // console.log(data);
                //         this.separator = data.data
                //     }).catch((e)=>{

                // })
            },
            Ahide(){
                this.$emit('whide',false);
            }
        }
    }
</script>

<style scoped lang="less">
    .pop-box1{
        background: url("./../assets/tc-bg.png") no-repeat;
        background-size: 100% 100%;
        width: 1136px;
        height: 572px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        z-index: 999;
        box-sizing: border-box;
        padding: 78px 33px;
        display: flex;
        justify-content: center;
        .close{
            background: url("./../assets/tc-close.png") no-repeat;
            background-size: 100% 100%;
            width: 13px;
            height: 12px;
            position: absolute;
            z-index: 999;
            top: 50px;
            right: 20px;
            cursor: pointer;

        }
    }
    .box-wargin{
        overflow: auto;
        width: 80%;
        height: 100%;
        position: relative;
        box-sizing: border-box;
        /* 设置滚动条的样式 */
        &::-webkit-scrollbar {
            width:5px;
        }
        /* 滚动槽 */
        &::-webkit-scrollbar-track {
            -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
            border-radius:10px;
        }
        /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
            border-radius:10px;
            background:rgba(0,0,0,0.1);
            -webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
        }
        &::-webkit-scrollbar-thumb {
            background:#9dc5fc;
        }
    }
    .list {
        width: 100%;
        height: 4vh;
        // border: 1px solid red;
        background-image: url("../assets/lisyt.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position-y: bottom;
        list-style: none;
        color: rgb(0, 255, 234);
        display: flex;
        align-items: center;
        position:sticky;
        top: 0;
        & li:first-child {
            width: 9vw;
            .displaY();
            height: 80%;
        }
        & li {
            width: 7.8vw;
            .displaY();
            height: 80%;
            font-size: 0.8vw;
            font-family: "SOURCEHANSANSCN-REGULAR";
            background-color: rgb(0, 63, 80);
            div {
                width: 10px;
                height: 2px;
                background: #00ffea;
            }
            span {
                margin: 0 0.5vw;
            }
        }
        & li:nth-child(5) ~ li {
            width: 8.1vw;
            .displaY();
            height: 80%;
        }
    }
    .list-now {
        width: 100%;
        height: 3vh;
        // border: 1px solid red;
        margin: 0.2vh 0;
        //   padding: 0.5vh 0;
        border-bottom: 1px dashed #63807e;
        .displaY();
        & li:first-child {
            width: 9vw;
            .displaY();
            height: 80%;
        }
        & li {
            width: 7.8vw;
            .displaY();
            height: 80%;
            color: rgb(255, 255, 255);
            font-size: 0.5vw;
        }

        & li:nth-child(5) ~ li {
            width: 8.1vw;
            .displaY();
            height: 80%;
        }
    }
    .list-now:last-child {
        border-bottom: none;
    }
    .list-now:nth-child(odd) {
        & li {
            background-color: rgba(0, 218, 215, 0.4);
        }
    }
</style>